/**
 * Line geometry for the animated hamburger ⇄ X glyph (STOK-17031 Step 11).
 *
 * Inlined from the design source glyphs:
 *   BARS      → app/leap/assets/svg/menu.svg  (closed / hamburger state)
 *   DIAGONALS → app/leap/assets/svg/close.svg (open / X state)
 *
 * `hamburger-icon.test.jsx` asserts these coordinates stay in sync with the two
 * source files.
 */
export const BARS = [
    {slot: 'barTop', x1: 4.81, y1: 5.8, x2: 19.19, y2: 5.8},
    {slot: 'barMiddle', x1: 4.81, y1: 12, x2: 19.19, y2: 12},
    {slot: 'barBottom', x1: 4.81, y1: 18.2, x2: 19.19, y2: 18.2}
]

export const DIAGONALS = [
    {slot: 'diagDown', x1: 5.68, y1: 5.68, x2: 18.32, y2: 18.32},
    {slot: 'diagUp', x1: 18.32, y1: 5.68, x2: 5.68, y2: 18.32}
]
